import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../base-query';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: createAuthenticatedBaseQuery(`${process.env.REACT_APP_API_URL}`),
  tagTypes: ['EducationClasses', 'MaxLessonsPerDay', 'TeacherWorkloads', 'Rooms', 'ClassGroups'],
  endpoints: () => ({}),
});
